import React from "react";
import { usePageData } from "../PageData";
import { SwiperCarousel } from "./SwiperCarousel";

export default function LandingSwiperCarousel({ onlyGroup = null }) {
  const data = usePageData();

  if (!data || !data.carouselBanners?.length) return null;

  const bannersByGroup = data.carouselBanners.reduce((acc, banner) => {
    const group = banner.carouselGroup ?? 0;
    if (!acc[group]) acc[group] = [];
    acc[group].push(banner);
    return acc;
  }, {});

  const groups = Object.entries(bannersByGroup).sort(([a], [b]) => a - b);

  return (
    <>
      {groups.map(([group, banners]) => {
        if (onlyGroup !== null && parseInt(group) !== onlyGroup) return null;
        return <SwiperCarousel key={group} banners={banners} />;
      })}
    </>
  );
}
